export function ToggleDefault({ ...props }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M15 10.9142L13.9142 12L15 13.0858C15.3905 13.4763 15.3905 14.1095 15 14.5C14.6095 14.8905 13.9763 14.8905 13.5858 14.5L11.7929 12.7071C11.4024 12.3166 11.4024 11.6834 11.7929 11.2929L13.5858 9.50001C13.9763 9.10949 14.6095 9.10949 15 9.50001C15.3905 9.89054 15.3905 10.5237 15 10.9142Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 2C19.3137 2 22 4.68629 22 8V16C22 19.3137 19.3137 22 16 22H8C4.68629 22 2 19.3137 2 16V8C2 4.68629 4.68629 2 8 2H16ZM9 20V4H16C18.2091 4 20 5.79086 20 8V16C20 18.2091 18.2091 20 16 20H9ZM7 4.12602V19.874C5.27477 19.4299 4 17.8638 4 16V8C4 6.13616 5.27477 4.57006 7 4.12602Z"
      />
    </svg>
  );
}
